import React from "react";
import Header from "../components/header";
import Footer from "../components/Footer";
import "./../main.css";

function RefundPolicty() {
    return (
        <>
            <Header />

            <section class="author-bg" style={{ padding: '16px', marginTop: '56px' }}>
                <div class="author-inner" style={{ textAlign: 'center' }}>
                    <h2 class="author-name" style={{ margin: '15px' }}>Refund Policy</h2>
                </div>
            </section>

            <section className="hero privacy-policy" style={{ textAlign: 'left' }}>
                <div className="privacy-container">
                    <p>
                        Thank you for your interest in this limited-edition publication.
                    </p>

                    <p>
                        This book is an individually hand-signed and individually numbered collectible edition limited to 1,776 numbered copies.
                    </p>

                    <h2>All Sales Are Final</h2>

                    <p>All sales are final at the time of purchase.</p>

                    <p>
                        Orders may not be canceled, modified, returned, or refunded after purchase except as expressly stated below or as required by applicable law.
                    </p>

                    <h2>Damaged or Defective Books</h2>

                    <p>Refunds or replacements may be provided only if:</p>

                    <ul>
                        <li>
                            The book arrives with material damage that occurred during shipping.
                            (Note: Minor cosmetic imperfections to the packaging or shipping materials that do not materially affect the book itself do not qualify for a refund or replacement.)
                        </li>
                    </ul>

                    <p>
                        Requests for refunds or replacements must be submitted within fourteen (14) days of delivery and may require photographs or other documentation.
                    </p>

                    <p>
                        The Company reserves the right, in its sole but reasonable discretion, to determine whether a refund, replacement, or other remedy is appropriate.
                    </p>

                    <h2>Replacement Copies</h2>

                    <p>
                        The Company may maintain a limited number of signed reserve copies for replacement purposes.
                    </p>

                    <p>
                        Reserve copies are maintained solely for replacement purposes and will not be offered for sale.
                    </p>

                    <p>
                        Replacement copies, if issued, may not bear the same edition number as the original book and may contain markings identifying them as replacement copies.
                    </p>

                    <h2>Lost or Stolen Packages</h2>

                    <p>
                        The Company is not responsible for packages that are marked as delivered by the shipping carrier but are subsequently lost or stolen.
                    </p>

                    <h2>Contact Us</h2>

                    <p>
                        Questions regarding this Refund Policy may be directed to:
                    </p>

                    <p>
                        <strong>Free State Solution (DeSantis 1776)</strong><br />
                        Email: <a href="mailto:Orders@DeSantis1776.com" className="linkto">
                            Orders@DeSantis1776.com
                        </a>
                    </p>

                </div>
            </section>

            <Footer />
        </>
    );
}

export default RefundPolicty;